var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "#013DB9",
    fillOpacity: 0.1,
    stroke: "#013DB9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M9.99994 22V9H11.8841V14.6494H18.1097V9H19.9999V22H18.1097V16.3315H11.8841V22H9.99994Z",
    fill: "#013DB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfileIcon);
export default __webpack_public_path__ + "static/media/new-profile-icon.6f15f24d7710332d228d755880514220.svg";
export { ForwardRef as ReactComponent };